import { useTranslation } from 'react-i18next'
import moment from 'moment'
import styled from 'styled-components'
import { ModifyOpeningHours, ModifyOpeningHoursDialogContent, Subtitle } from 'pages/Home/styles'
import colors from 'globals/colors'
import { PencilIcon } from 'components/Icons'
import { useState } from 'react'
import Dialog from 'components/Dialog'
import { Input } from 'components'
import SubmitButton from 'components/SubmitButton'
import { Formik } from 'formik'
import { OPENING_HOURS_UPDATE } from 'pages/Home/mutations'
import { useMutation } from '@apollo/client'

const OpeningHoursUpdate = ({ currentCenters }) => {
  const { t } = useTranslation()
  const openingHours = currentCenters[0].openingHours

  const [showModifyOpeningHours, setShowModifyOpeningHours] = useState(false)
  const [openingHoursUpdate] = useMutation(OPENING_HOURS_UPDATE)

  const placeholderExample = `${t('days.Monday')}: 09:00 - 17:00
${t('days.Tuesday')}: 09:00 - 17:00
${t('days.Wednesday')}: 09:00 - 17:00
${t('days.Thursday')}: 09:00 - 17:00
${t('days.Friday')}: 09:00 - 17:00`

  const onFinish = (values) => {
    openingHoursUpdate({
      variables: {
        message: values.comment,
        addressId: currentCenters[0].id
      }
    }).then(() => {
      setShowModifyOpeningHours(false)
    })
  }

  if (!openingHours) {
    return null
  }

  return (
    <OpeningHoursWrapper>
      <Subtitle>{t('home.center.opening-hours')}</Subtitle>

      <ul>
        {openingHours.map((hour) => (
          <li key={hour.id}>
            {t('days.' + hour.day)}: {moment(hour.openTime).utc().format('HH:mm')} -{' '}
            {moment(hour.closeTime).utc().format('HH:mm')}
          </li>
        ))}
      </ul>

      <ModifyOpeningHours onClick={() => setShowModifyOpeningHours(true)}>
        {t('global.modify')}
        <PencilIcon />
      </ModifyOpeningHours>

      <Dialog visible={showModifyOpeningHours} onClose={() => setShowModifyOpeningHours(false)}>
        <ModifyOpeningHoursDialogContent>
          <b>{t('home.center.modify-hours')}</b>
          <Formik
            initialValues={{
              comment: openingHours
                .map(
                  (hour) =>
                    `${t('days.' + hour.day)}: ${moment(hour.openTime).utc().format('HH:mm')} - ${moment(hour.closeTime)
                      .utc()
                      .format('HH:mm')}`
                )
                .join('\n')
            }}
            onSubmit={onFinish}
          >
            {() => (
              <div>
                <Input name='comment' type='multiline' rows={7} placeholder={placeholderExample} />
                <p>{t('home.center.hours-updated-description')}</p>
                <SubmitButton text={t('global.send')} />
              </div>
            )}
          </Formik>
        </ModifyOpeningHoursDialogContent>
      </Dialog>
    </OpeningHoursWrapper>
  )
}

const OpeningHoursWrapper = styled.div`
  margin-top: 24px;

  & > ul {
    line-height: 22px;
    color: ${colors.steelGrey};
    padding: 0;
    margin: 0;
    list-style-type: none;
  }
`

export default OpeningHoursUpdate
